import { defineMessages } from 'react-intl';

const messages = defineMessages({
  blockTitle: {
    id: 'setMenu.blockTitle',
    defaultMessage: 'Menu à prix fixe',
  },
  defaultFieldset: {
    id: 'setMenu.defaultFieldset',
    defaultMessage: 'Default',
  },
  coursesFieldset: {
    id: 'setMenu.coursesFieldset',
    defaultMessage: 'Services',
  },
  eyebrow: {
    id: 'setMenu.eyebrow',
    defaultMessage: 'Sur-titre',
  },
  heading: {
    id: 'setMenu.heading',
    defaultMessage: 'Titre',
  },
  price: {
    id: 'setMenu.price',
    defaultMessage: 'Prix',
  },
  priceNote: {
    id: 'setMenu.priceNote',
    defaultMessage: 'Mention du prix',
  },
  serviceNote: {
    id: 'setMenu.serviceNote',
    defaultMessage: 'Note de service',
  },
  serviceNoteDescription: {
    id: 'setMenu.serviceNoteDescription',
    defaultMessage: 'Quand le menu est servi, par exemple « Tous les midis ».',
  },
  closingNote: {
    id: 'setMenu.closingNote',
    defaultMessage: 'Note de fin',
  },
  showAllergenNotice: {
    id: 'setMenu.showAllergenNotice',
    defaultMessage: 'Afficher la mention allergènes',
  },
  image: {
    id: 'setMenu.image',
    defaultMessage: 'Photo (optionnelle)',
  },
  imageDescription: {
    id: 'setMenu.imageDescription',
    defaultMessage:
      'Affichée à côté du menu sur grand écran, au-dessus sur mobile. Format conseillé : portrait 4:5.',
  },
  courses: {
    id: 'setMenu.courses',
    defaultMessage: 'Services',
  },
  course: {
    id: 'setMenu.course',
    defaultMessage: 'Service',
  },
  addCourse: {
    id: 'setMenu.addCourse',
    defaultMessage: '+ Ajouter un service',
  },
  courseLabel: {
    id: 'setMenu.courseLabel',
    defaultMessage: 'Intitulé',
  },
  choices: {
    id: 'setMenu.choices',
    defaultMessage: 'Choix',
  },
  choice: {
    id: 'setMenu.choice',
    defaultMessage: 'Plat',
  },
  addChoice: {
    id: 'setMenu.addChoice',
    defaultMessage: '+ Ajouter un choix',
  },
  choiceTitle: {
    id: 'setMenu.choiceTitle',
    defaultMessage: 'Plat',
  },
  eyebrowPlaceholder: {
    id: 'setMenu.eyebrowPlaceholder',
    defaultMessage: 'Sur-titre (Menu, Lunch…)',
  },
  headingPlaceholder: {
    id: 'setMenu.headingPlaceholder',
    defaultMessage: 'Titre (Entrée, plat et dessert…)',
  },
  pricePlaceholder: {
    id: 'setMenu.pricePlaceholder',
    defaultMessage: 'Prix (55 €)',
  },
  priceNotePlaceholder: {
    id: 'setMenu.priceNotePlaceholder',
    defaultMessage: 'par personne',
  },
  serviceNotePlaceholder: {
    id: 'setMenu.serviceNotePlaceholder',
    defaultMessage: 'Note de service (Tous les midis sauf…)',
  },
  closingNotePlaceholder: {
    id: 'setMenu.closingNotePlaceholder',
    defaultMessage: 'Note de fin (Réservation au…)',
  },
  courseLabelPlaceholder: {
    id: 'setMenu.courseLabelPlaceholder',
    defaultMessage: 'Service (Entrées, Plats…)',
  },
  choicePlaceholder: {
    id: 'setMenu.choicePlaceholder',
    defaultMessage: 'Nom du plat',
  },
  or: {
    id: 'setMenu.or',
    defaultMessage: 'ou',
  },
  removeCourse: {
    id: 'setMenu.removeCourse',
    defaultMessage: 'Supprimer le service {label}',
  },
  removeCourseFallback: {
    id: 'setMenu.removeCourseFallback',
    defaultMessage: 'sans nom',
  },
  removeChoice: {
    id: 'setMenu.removeChoice',
    defaultMessage: 'Supprimer {title}',
  },
  removeChoiceFallback: {
    id: 'setMenu.removeChoiceFallback',
    defaultMessage: 'ce plat',
  },
  emptyState: {
    id: 'setMenu.emptyState',
    defaultMessage:
      'Aucun service pour l’instant. Cliquez sur « + Ajouter un service ».',
  },
});

export default messages;
